module.exports = __webpack_public_path__ + "img/layout_fish_right.5883508f.svg";